import { Component, OnInit, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TruckAnnouncementService } from '../../core/api/truck-announcement.service';
import { TruckAnnouncementPinListItem } from '../../shared/models/truck-announcement';
import { AppNavComponent } from '../../shared/app-nav.component';
import { BackButtonComponent } from '../../shared/back-button.component';
import { TranslatePipe } from '../../shared/translate.pipe';

@Component({
  standalone: true,
  imports: [RouterLink, AppNavComponent, BackButtonComponent, TranslatePipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <app-back></app-back>
        <h1>{{ 'ta.pinListTitle' | t }}</h1>
      </header>
      <div class="search-bar">
        <input type="search" [placeholder]="'common.search' | t" [value]="query()" (input)="query.set($any($event.target).value)">
      </div>

      @if (loading()) {
        <div class="skeleton-list">
          @for (i of [1,2,3,4,5,6]; track i) { <div class="skeleton-row"></div> }
        </div>
      }
      @if (error()) { <p class="error notice">{{ error() | t }}</p> }
      <section class="list">
        @for (item of filtered(); track item.Id) {
          <a class="list-row card-style tone-amber" [routerLink]="['/truck-announcement-pins', item.Id]">
            <div class="card-style-header">
              <strong>{{ item.PIN || ('ta.pinFallback' | t) }}</strong>
              <span class="id-badge">{{ item.Id }}</span>
            </div>
            <dl class="card-fields">
              <div class="field-row"><dt>{{ 'ta.pin' | t }}</dt><dd>{{ item.PIN || '—' }}</dd></div>
              <div class="field-row"><dt>{{ 'wo.serviceRequest' | t }}</dt><dd>{{ item.ServiceRequest || '—' }}</dd></div>
              <div class="field-row"><dt>{{ 'common.id' | t }}</dt><dd>{{ item.Id }}</dd></div>
              <div class="field-row"><dt>{{ 'ta.terminalOperator' | t }}</dt><dd>{{ item.TerminalOperatorName || '—' }}</dd></div>
            </dl>
          </a>
        } @empty { @if (!loading() && !error()) {
          <div class="empty-state">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16v13H4z"/><path d="M4 7l3-4h10l3 4"/><path d="M9 11h6"/></svg>
            <span>{{ 'ta.pinListEmpty' | t }}</span>
          </div>
        } }
      </section>
    </main>
  `
})
export class TruckAnnouncementPinsPage implements OnInit {
  readonly items = signal<TruckAnnouncementPinListItem[]>([]);
  readonly loading = signal(true);
  readonly error = signal('');
  readonly query = signal('');
  readonly filtered = computed(() => {
    const q = this.query().trim().toLowerCase();
    if (!q) return this.items();
    return this.items().filter(item =>
      String(item.Id).includes(q) ||
      (item.PIN ?? '').toLowerCase().includes(q) ||
      (item.ServiceRequest ?? '').toLowerCase().includes(q) ||
      (item.TerminalOperatorName ?? '').toLowerCase().includes(q) ||
      (item.WarehouseName ?? '').toLowerCase().includes(q)
    );
  });

  constructor(private readonly api: TruckAnnouncementService) {}

  ngOnInit(): void {
    this.api.searchPins({ Page: 1, PageSize: 50 }).subscribe({
      next: items => { this.items.set(items); this.loading.set(false); },
      error: err => { this.error.set(err?.error?.Message ?? err?.error?.message ?? 'ta.pinListError'); this.loading.set(false); }
    });
  }
}
